import axios, { AxiosResponse } from "axios";

// Models
import { CgiCollectRequest, CgiCollectResponse, CgiInitRequest, CgiInitResponse } from "../models/CGI/CGI";

class CgiService {
    private client;

    constructor() {
        this.client = axios.create({
            baseURL: process.env.AEA_API_URL
        });
    }

    init(request: CgiInitRequest): Promise<AxiosResponse<CgiInitResponse>> {
        return this.client.post<CgiInitResponse>('/umbraco/surface/formsurface/cgiinit', request);
    }

    collect(request: CgiCollectRequest): Promise<AxiosResponse<CgiCollectResponse>> {
        return this.client.post<CgiCollectResponse>('/umbraco/surface/formsurface/cgicollect', request);
    }
}

export default CgiService;